module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSales
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Assignment Form")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.salesListData.allModuleId ? this.salesListData.allModuleId : '',
      "jobSeriesBanner": this.salesListData.salesSeries ? this.salesListData.salesSeries : '',
      "bannerClientName": this.salesListData.clientName ? this.salesListData.clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(
    (_vm.quotationFinal.statusAct == 'Approved' &&
      _vm.assignmentList.assignId != '') ||
    (_vm.viewAllAssignment.length == 0 &&
      _vm.quotationFinal.statusAct == 'Approved') ||
    _vm.showMainAssign
  ) ? _c('div', {
    staticClass: "phone-viewport",
    attrs: {
      "id": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning",
      "size": "sm",
      "disabled": _vm.permissionStatus ? true : false
    },
    on: {
      "click": _vm.showMoreItem
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.showMoreNewItem == true ? "Hide" : "Show More"))])]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showMoreNewItem == true) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Quotation No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "assignQuotationId",
      "id": "assignQuotationId",
      "disabled": ""
    },
    model: {
      value: (_vm.assignmentList.quotationSeries),
      callback: function($$v) {
        _vm.$set(_vm.assignmentList, "quotationSeries", $$v)
      },
      expression: "assignmentList.quotationSeries"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "clientName",
      "id": "clientName",
      "disabled": ""
    },
    model: {
      value: (_vm.quotationList.clientName),
      callback: function($$v) {
        _vm.$set(_vm.quotationList, "clientName", $$v)
      },
      expression: "quotationList.clientName"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showMoreNewItem == true) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMoreNewItem == true) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Pickup Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "fromLocation",
      "id": "fromLocation",
      "disabled": ""
    },
    model: {
      value: (_vm.assignmentList.fromLocation),
      callback: function($$v) {
        _vm.$set(_vm.assignmentList, "fromLocation", $$v)
      },
      expression: "assignmentList.fromLocation"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Stuffing Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "toLocation",
      "id": "toLocation",
      "disabled": ""
    },
    model: {
      value: (_vm.quotationList.StuffingLocation),
      callback: function($$v) {
        _vm.$set(_vm.quotationList, "StuffingLocation", $$v)
      },
      expression: "quotationList.StuffingLocation"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Handover Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "toLocation",
      "id": "toLocation",
      "disabled": ""
    },
    model: {
      value: (_vm.assignmentList.toLocation),
      callback: function($$v) {
        _vm.$set(_vm.assignmentList, "toLocation", $$v)
      },
      expression: "assignmentList.toLocation"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No. of Vehicle Requried *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "name": "noOfTrucks",
      "id": "noOfTrucks"
    },
    on: {
      "keyup": _vm.totalCostFinal
    },
    model: {
      value: (_vm.assignmentList.noOfTrucks),
      callback: function($$v) {
        _vm.$set(_vm.assignmentList, "noOfTrucks", $$v)
      },
      expression: "assignmentList.noOfTrucks"
    }
  })], 1), _vm._v(" "), (!_vm.assignmentList.noOfTrucks) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.noOfTrucksError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Cargo Weight(in Tons) *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "cargoWeight",
      "id": "cargoWeight",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.assignmentList.cargoWeight),
      callback: function($$v) {
        _vm.$set(_vm.assignmentList, "cargoWeight", $$v)
      },
      expression: "assignmentList.cargoWeight"
    }
  })], 1), _vm._v(" "), (!_vm.assignmentList.cargoWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.cargoWeightError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Booking No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "bookingNo",
      "id": "bookingNo",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.assignmentList.bookingNo),
      callback: function($$v) {
        _vm.$set(_vm.assignmentList, "bookingNo", $$v)
      },
      expression: "assignmentList.bookingNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.assignmentList.noOfTrucks > 1) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "my-test9",
      "name": "my-test9"
    },
    on: {
      "change": _vm.showMultipleCargo
    },
    model: {
      value: (_vm.checkCargo),
      callback: function($$v) {
        _vm.checkCargo = $$v
      },
      expression: "checkCargo"
    }
  }, [_vm._v("Select Cargo Weight if different for multiple\n                  truck")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multipleCargoValue.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.multipleCargoValue), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "25"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "80"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('label', [_vm._v("Truck " + _vm._s(index + 1) + " Cargo Wgt(in Tons)")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (_vm.multipleCargoValue[index]),
        callback: function($$v) {
          _vm.$set(_vm.multipleCargoValue, index, $$v)
        },
        expression: "multipleCargoValue[index]"
      }
    })], 1)], 1)], 1)
  })) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1111",
      "disabled": _vm.permissionStatus ? true : false
    },
    on: {
      "click": _vm.vehicleBooking
    }
  }, [_vm._v("Save & Proceed")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1111"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.assignmentList.ExecutionCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.assignmentList.ExecutionCreated))])]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.assignmentList.ExecutionUpdated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.assignmentList.ExecutionUpdated))])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.viewAllAssignment.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(
    _vm.ExecConCount != _vm.quoationConCount &&
    _vm.quoationConCount < _vm.ExecConCount
  ) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "outline-dark",
      "size": "sm",
      "disabled": _vm.$sessionsStorage.get('storeExpireStatus') == '1' ||
        _vm.$sessionsStorage.get('storeExpireStatus') == 'null' ?
        true :
        false
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v(_vm._s(!_vm.showMainAssign ? "New" : "Hide") + " Assignment")]) : _vm._e(), _vm._v(" "), (
    _vm.$sessionsStorage.get('storeExpireStatus') == '1' ||
    _vm.$sessionsStorage.get('storeExpireStatus') == 'null'
  ) ? _c('h3', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                Note : Quotation Validity Has been Expired. Cannot Create New\n                Assignment..!\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Assignment")]), _vm._v(" "), _c('th', [_vm._v("Location Details")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Details")]), _vm._v(" "), _c('th', [_vm._v("Container Details")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.viewAllAssignment), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.showAssignmentData(item)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.assignSeries) + "\n                    ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Pickup Location :")]), _vm._v("\n                      " + _vm._s(item.PICK) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Factory Location :")]), _vm._v("\n                      " + _vm._s(item.STUFF) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Handover Location :")]), _vm._v("\n                      " + _vm._s(item.HAND) + "\n                    ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Vehicle Requried :")]), _vm._v("\n                      " + _vm._s(item.noOfTrucks) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Cargo Weight :")]), _vm._v("\n                      " + _vm._s(item.multipleCargoValue == "" ?
      item.cargoWeight :
      item.multipleCargoValue) + "\n                    ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Container No. :")]), _vm._v("\n                      " + _vm._s(item.AllContainerNo) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Container Type :")]), _vm._v("\n                      " + _vm._s(item.AllContainersType) + "\n                    ")]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "variant": "outline-success",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.goToGRN(item)
        }
      }
    }, [_vm._v("Proceeed To GRN")])], 1)])
  }))])])]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop1",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose1
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c75d4fd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/quotation.vue
// module id = 2539
// module chunks = 0